import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "format-toolbar" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "button-container" }

import { useStore } from 'vuex';
  import { computed,onMounted,ref,watch,reactive } from 'vue';
  import { TelegramClient } from "@/websocket/Client";
  import { message } from "ant-design-vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'text',
  setup(__props) {

  const store = useStore();
  const content = ref('');
  const client = TelegramClient.getInstance();
  const onKeyup = (e: KeyboardEvent) => {
    if (e.ctrlKey && e.keyCode === 13 && content.value.length) {
      store.commit('SEND_MESSAGE', content.value);
      content.value = '';
    }
  };

// 添加链接编辑对话框的状态
const linkModalVisible = ref(false)
const linkForm = reactive({
  text: '',
  url: ''
})

// const formState = reactive({
//   message: "",
// });

// 修改格式化方法
const formatText = {
  bold: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`*${selected}*`, start, end);
  },

  italic: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`_${selected}_`, start, end);
  },

  underline: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`__${selected}__`, start, end);
  },

  strikethrough: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`~${selected}~`, start, end);
  },

  code: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`${selected}\``, start, end);
  },

  codeblock: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`\`\`\n${selected}\n\`\`\``, start, end);
  },

  spoiler: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`||${selected}||`, start, end);
  },

  quote: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    // 处理多行引用
    const formatted = selected.split('\n').map(line => `> ${line}`).join('\n');
    insertText(formatted, start, end);
  },

  link: () => {
    console.log("link");
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const text = textarea.value;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    linkForm.text = text.substring(start, end);
    linkForm.url = '';
    
    // 保存当前光标位置
    const currentPos = { start, end };
    (textarea as any).savedPos = currentPos;
    
    // 显示链接编辑对话框
    linkModalVisible.value = true;
  }
};

// 辅助函数：插入文本
const insertText = (newText: string, start: number, end: number) => {
  const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const text = textarea.value;
  content.value = text.substring(0, start) + newText + text.substring(end);
  
  // 恢复焦点并更新光标位置
  textarea.focus();
  const newPosition = start + newText.length;
  textarea.setSelectionRange(newPosition, newPosition);
};

// 处理链接确认
const handleLinkConfirm = () => {
  const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const { start, end } = (textarea as any).savedPos || { start: 0, end: 0 };
  const linkMarkdown = `[${linkForm.text}](${linkForm.url})`;
  
  insertText(linkMarkdown, start, end);
  linkModalVisible.value = false;
  console.log("dadf");
};

 

  // WebSocket 消息监听
  onMounted(() => {
    //refreshReceiverList();

  });

 

  const currentId = computed<number>(() => store.state.currentSessionId);

 
 const handleSendPostMan = async() => {
    var chatTarget = store.state.currentSessionId;
    console.log("handleSendMsg2="+chatTarget);
    if(content.value == "")
    {
      message.error(`发送失败: 发送内容为空`);
      return;
    }
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    var chatTarget = store.state.currentSessionId;
    var targets = [{Id:chatTarget}];
    var msg = "[POSTMAN]" + content.value;
    const result = await client.sendMessage(
      account,
      name,
      targets,
      content.value,
      2
    );

    if (result && result.code === 1) {
      store.commit('SEND_MESSAGE', msg);
      content.value = '';
    } else {
      const errorMsg = result?.reason || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
 
  };

 
  
  const handleFileUpload =(event) => {
      const file = event.target.files[0];

      if (file) {
         convertToBase64(file);
      }
    }


    const convertToBase64 =(file)=> {
      const reader = new FileReader();

      reader.onload = (e) => {
        var base64Image = e.target.result; // Set the base64 data
        //store.commit('SEND_MESSAGE', base64Image);
        handleSendImageMsg(base64Image);
        console.log("onload="+base64Image);
      };

      reader.onerror = (error) => {
        console.log('Error: ', error); // Handle errors
      };

      reader.readAsDataURL(file); // Read the file as a data URL
    }
 


    const handleSendImageMsg = async(base64Image) => {
    var chatTarget = store.state.currentSessionId;
    console.log("handleSendMsg2="+chatTarget);
    if(base64Image == "")
    {
      message.error(`发送失败: base64Image为空`);
      return;
    }
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    var chatTarget = store.state.currentSessionId;
    var targets = [{Id:chatTarget}];
    const result = await client.sendMessage(
      account,
      name,
      targets,
      base64Image,
      1
    );

    if (result && result.code === 1) {
      store.commit('SEND_MESSAGE', base64Image);
    } else {
      const errorMsg = result?.reason || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
 
  };



  const handleSendMsg = async() => {
    var chatTarget = store.state.currentSessionId;
    console.log("handleSendMsg2="+chatTarget);
    if(content.value == "")
    {
      message.error(`发送失败: 发送内容为空`);
      return;
    }
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    var chatTarget = store.state.currentSessionId;
    var targets = [{Id:chatTarget}];
    const result = await client.sendMessage(
      account,
      name,
      targets,
      content.value,
      1
    );

    if (result && result.code === 1) {
      store.commit('SEND_MESSAGE', content.value);
      content.value = '';
    } else {
      const errorMsg = result?.reason || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
 
  };


  
return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_button_group = _resolveComponent("a-button-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            onClick: formatText.bold,
            title: "粗体"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("B")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: formatText.italic,
            title: "斜体"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("I")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: formatText.underline,
            title: "下划线"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("U")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: formatText.strikethrough,
            title: "删除线"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("S")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: formatText.code,
            title: "行内代码"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("{}")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: formatText.codeblock,
            title: "代码块"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("{ }")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: formatText.link,
            title: "添加链接"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("🔗")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: formatText.spoiler,
            title: "隐藏文本"
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("��")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: formatText.quote,
            title: "引用"
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("\"")
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "按 Ctrl + Enter 发送",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
        onKeyup: onKeyup
      }, null, 544), [
        [_vModelText, content.value]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"width":"100px"},
          onClick: handleSendPostMan
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("POSTMAN")
          ])),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"width":"100px"},
          onClick: handleSendMsg
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("发送")
          ])),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: linkModalVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((linkModalVisible).value = $event)),
      title: "添加链接",
      onOk: handleLinkConfirm,
      okText: "确定",
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: linkForm,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "链接文字" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: linkForm.text,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((linkForm.text) = $event)),
                  placeholder: "请输入链接显示的文字"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "链接地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: linkForm.url,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((linkForm.url) = $event)),
                  placeholder: "请输入链接地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})